<!-- TÍTULO PRINCIPAL -->
<div class="container validacion-doc-container">
  <div class="row justify-content-center">
    <div class="col-12 text-center mt-3 mb-2">
      <h1 class="letra-titulo mb-1">Validación de documentos médicos</h1>
      <p class="textoModal mb-0">
        Ingresa el código de verificación que aparece en el documento médico para validar su autenticidad.
      </p>
    </div>
  </div>

  <div class="row justify-content-center mt-4 mb-5">
    <div class="col-12 col-sm-10 col-md-8 col-lg-5">
      <div class="card-padre d-flex flex-column">

        <!-- HEADER CARD -->
        <div class="card-datos d-flex align-items-center">
          <div>
            <h2 class="letra-card-titulo mb-0">Ingrese el código de verificación</h2>
            
          </div>
        </div>

        <!-- CONTENIDO -->
        <div class="card-body px-4 pt-4 pb-3 flex-grow-1">

          <!-- FORM -->
          <form #formCodigo="ngForm" (ngSubmit)="buscarDocumento()">
            <div class="form-group text-left">
              <label for="id_documento" class="label-input mb-1">
                Código de verificación
              </label>
              <input
                id="id_documento"
                type="text"
                name="id_documento"
                class="form-control inputModal"
                required
                minlength="6"
                maxlength="30"
                autocomplete="off"
                [(ngModel)]="datos_url.id_documento"
                #codigo="ngModel"
                (ngModelChange)="onChange($event)"
                placeholder="Ej: CI1691820251204110359P" />

              <!-- Mensajes de validación -->
              <div class="invalid-feedback d-block mt-1" *ngIf="codigo.invalid && (codigo.dirty || codigo.touched)">
                <span *ngIf="codigo.errors?.required">
                  El código de verificación es obligatorio.
                </span>
                <span *ngIf="codigo.errors?.minlength">
                  El código debe tener al menos {{ codigo.errors?.minlength.requiredLength }} caracteres.
                </span>
              </div>
            </div>

            <!-- MENSAJE INFORMATIVO INICIAL (antes de buscar) -->
            <div *ngIf="!datos_documento?.att_path && !hasSearched && !isLoading" class="alert alert-light info-box">
              Ingresa el código  para continuar.
            </div>

            <!-- ESTADO: BUSCANDO -->
            <div *ngIf="isLoading" class="alert alert-primary info-box mb-2">
              Estamos verificando el documento, por favor espera...
            </div>

            <!-- ESTADO: ERROR / NO ENCONTRADO -->
            <div *ngIf="!isLoading && hasSearched && !datos_documento?.att_path" class="alert alert-danger info-box mb-2">
              No encontramos un documento asociado a este código. Revisa que esté bien escrito.
            </div>

            <!-- ESTADO: DOCUMENTO ENCONTRADO -->
            <div *ngIf="datos_documento?.att_path" class="mt-3">

              <!-- Documento firmado -->
              <p *ngIf="datos_documento.att_typ_id == 5"
                 class="estado-doc estado-doc-ok">
                Documento firmado electrónicamente
              </p>

              <!-- Documento retenido -->
              <p *ngIf="datos_documento.sta_id == 45"
                 class="estado-doc estado-doc-ret">
                Documento retenido el {{ datos_documento.fecha_retencion }}
              </p>

              <!-- Documento válido / descargable -->
              <div
                *ngIf="datos_documento.sta_id == 33 || datos_documento.sta_id == 31 || datos_documento.sta_id == 40"
                class="mt-3 text-center">
                <button
                  type="button"
                  class="btn btn-secondary letraBotonModal btn-descargar"
                >
                  <a
                    [href]="pdf_url"
                    download="documento_medico"
                    style="color: #fff; text-decoration: none;"
                  >
                                      Descargar documento
                  </a>
                </button>
              </div>
            </div>

            <!-- BOTONES -->
            <div class="mt-4 d-flex justify-content-between" style="flex-direction: column; align-items: center;">
              <div class="row w-100">
                <div class="col-6">
                  <button
                    type="submit"
                    class="btn letraBotonModal btn-verificar flex-grow-1 mr-2"
                    [disabled]="formCodigo.invalid || isLoading"
                  >
                    Verificar
                  </button>
                </div>
                <div class="col-6">
                  <button
                    *ngIf="datos_documento?.att_path && datos_documento?.sta_id == 33"
                    type="button"
                    class="btn letraBotonModal btn-retener flex-grow-1 ml-2"
                    (click)="retenerModal()"
                  >
                    Retener
                  </button>
                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL PREVISUALIZAR (puedes mantenerlo igual, solo ajusté clases) -->
<div
  class="modal fade"
  id="previsualizardocumento"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  #previsualizardocumento
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body">

        <p class="tituloModalEliminar" style="text-align: center;margin: 0%;width: auto;">
          Ver documento
        </p>

        <div style="width: auto;height: 450px;">
          <!-- Aquí iría tu iframe/embed si lo vuelves a habilitar -->
          <!--
          <iframe
            [src]="pdf_url | safeUrl"
            style="width: 100%;border: none;margin: 0;padding: 0;overflow: hidden;z-index: 3;height: 100%;"
          ></iframe>
          -->
        </div>

        <div class="container-fluid text-center mt-3 mb-2">
          <button type="button" class="btn btn-secondary letraBotonModal" data-dismiss="modal">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
